export default function getCompiledProjects(state) {
  return state.get('compiledProjects');
}
